export const stripChars = (s, chars = '') => {
    if (!s) {
        return;
    }

    let value = s;

    [...chars].forEach(char => {
        value = value.replaceAll(char, '');
    });

    return value;
};
